import { lazy, Suspense } from 'react'

import { resolveStepRules } from '@ngb-frontend/shared/rules'
import {
  StepVariants,
  type ServiceLocationStepAnyMergedData,
  type ServiceLocationStepAnyStepData,
  type StepComponentContainer,
} from '@ngb-frontend/shared/types'
import {
  hasEndOfLeaseFormValues,
  hasLocationValues,
  hasMaintenanceAndRepairFormValues,
} from '@ngb-frontend/shared/utils'

import { FullScreenLoader } from '../../FullScreenLoader/FullScreenLoader'

const ServiceLocationStepLazy = lazy(() => import('./ServiceLocationStep'))

export const ServiceLocationStepContainer: StepComponentContainer<
  ServiceLocationStepAnyStepData,
  ServiceLocationStepAnyMergedData
> = (props) => {
  return (
    <Suspense fallback={<FullScreenLoader />}>
      <ServiceLocationStepLazy {...props} />
    </Suspense>
  )
}

ServiceLocationStepContainer.getVariant = (mergedFlowData) =>
  mergedFlowData.extraServices?.includes('PickupAndReturn') ||
  mergedFlowData.services?.includes('EOL')
    ? StepVariants.ServiceLocationWithPickup
    : StepVariants.ServiceLocation

function areStepPrerequisitesMet(
  mergedFlowData: Partial<ServiceLocationStepAnyMergedData>,
): mergedFlowData is ServiceLocationStepAnyMergedData {
  return (
    hasMaintenanceAndRepairFormValues(mergedFlowData) ||
    hasEndOfLeaseFormValues(mergedFlowData) ||
    hasLocationValues(mergedFlowData)
  )
}

ServiceLocationStepContainer.areStepPrerequisitesMet = areStepPrerequisitesMet

ServiceLocationStepContainer.skip = (mergedFlowData, _, countryConfig) => ({
  enabled:
    !!mergedFlowData?.extraServices?.includes('PickupAndReturn') &&
    resolveStepRules({ countryConfig }).autopickSupplier,
  state: { supplier: undefined },
})
